import { useState } from "react"
import { CommaFire } from "../CommaFire"

export declare type InputProps = {
    name: string,
    title: string,
    type: string,
    required?: boolean,
    errorMessage?: string,
    unit?: string,
    display_value?: boolean,
    custom_class?: string,
    deisable?:boolean ,
}

export const CInputText = ({ name, title, type, required, errorMessage, unit, display_value, custom_class , deisable }: InputProps) => {
    const [inputValue, setInputValue] = useState(null)

    const handelOnchange = (e: any) => {
        setInputValue(e.target.value)
    }

    return (
        <div className="flex flex-col mb-[30px] transition-all">
            <div className="flex relative px-[7px] min-h-[50px] rounded-[5px] items-center border border-dayan-gray-100 mb-[3px] focus-within:border-2 focus-within:border-dayan-orange-50">
                <span className="text-[12px] text-dayan-gray-100 absolute bg-white top-[-12px] right-[15px] px-[10px]">{title}</span>
                <input name={name} onChange={(e: any) => handelOnchange(e)} className={` w-full h-[35px]  sm:text-[13px] text-[11px] focus:outline-none ${custom_class} ${deisable && 'cursor-not-allowed'}`} type={type} required={required == true ? true : false} disabled={deisable ? deisable : false} />
            </div>
            <span className={`page-layout-form-item-show-value ${display_value == true && inputValue != null && inputValue != '' && 'page-layout-form-item-show-value-active'}`}>
                {display_value == true && inputValue != null && inputValue != '' && CommaFire(inputValue)} {unit}
            </span>
        </div>
    );
}